import { InjectionToken } from '@angular/core'
import { NavigationLink } from '../../shared/models/interfaces'

export const DASHBOARD_SIDEBAR_MENU = new InjectionToken<NavigationLink[]>('DashboardSidebarMenu')
